import { relaxPopupAlertTrigger } from './module/relaxPopupAlert/relaxPopupAlert.module';
import { PreloaderModule } from './module/preloader/preloader.module';
import { DecoderModule } from './module/decoder/decoder.module';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import {
  APP_INITIALIZER,
  ErrorHandler,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { createTranslateLoader } from './translate/translate.factory';
import { LoginService } from './services/login.service';
import { BrandingService } from './services/branding.service';
import { HttpService } from './util/HttpService';
import { UtilService } from './util/UtilService';
import { TutorialModule } from './module/tutorial/tutorial.module';
import { SelectInfoModule } from './module/selectinfo/selectinfo.module';
import { SelectHistoryModule } from './module/selecthistory/selecthistory.module';
import { SelectSettingsModule } from './module/selectsettings/selectsettings.module';
import { TableInfopopupModule } from './module/tableinfopopup/tableinfopopup.module';

import * as $ from 'jquery'; // Import jQuery. its needed for createjs
import * as createjs from 'createjs-module'; // Import createjs its needed for canvas and game animations
import 'hammerjs';

import { ComingSoonModule } from './module/comingsoon/comingsoon.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SelectLanguageModule } from './module/selectlanguage/selectlanguage.module';
import { HttpConfigInterceptor } from './interceptor/httpconfig.interceptor';
import { RetryInterceptor } from './interceptor/retry.interceptor';
import { AppErrorModule } from './module/apperror/apperror.module';
import { ErrorPopupService } from './services/error.popup.service';

import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';

import { FCGLayoutComponent } from './page/lobby/fcg/core/fcg.layout.component';
import { FC21LayoutComponent } from './page/lobby/fc21/core/fc21.layout.component';
import { FavoriteInfoModule } from './module/favoriteinfo/favoriteinfo.module';

import { PlayForFunAlertModule } from './module/playforfunalert/playforfunalert.module';
import { ResizeModule } from 'src/framework/resize/resize.module';
import { AlertPlayerRegisterPopupModule } from './module/alertPlayerRegisterPopup/alertPlayerRegisterPopup.module';
import { LoaderService } from './services/loader.service';
import { SelectSymbolsModule } from './module/selectsymbols/selectsymbols.module';
import { alertInsufficientPopupModule } from './module/alertInsufficientPopup/alertInsufficientPopup.module';
import { AlertLiveDealerNoSeatAvailableTrigger } from './module/alertlivedealernoseatavailable/alertlivedealernoseatavailable.module';
import { BetLimitPopupModule } from './module/betlimitpopup/betlimitpopup.module';

import { APP_BASE_HREF } from '@angular/common';

import { AppInitService, ANALYTICS_INSTANCE } from './app-init.service';

export function appInitializerFactory() {
  const appInitService = inject(AppInitService);
  return () => appInitService.initAppParams(); // Note: this function returns another function
}

@NgModule({
  declarations: [AppComponent, FCGLayoutComponent, FC21LayoutComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    TutorialModule,
    SelectInfoModule,
    SelectHistoryModule,
    SelectSettingsModule,
    SelectLanguageModule,
    TableInfopopupModule,
    PlayForFunAlertModule,
    AlertPlayerRegisterPopupModule,
    FavoriteInfoModule,
    HammerModule,
    alertInsufficientPopupModule,
    ComingSoonModule,
    AppErrorModule,
    DecoderModule,
    ResizeModule,
    PreloaderModule,
    ReactiveFormsModule,
    SelectSymbolsModule,
    AlertLiveDealerNoSeatAvailableTrigger,
    relaxPopupAlertTrigger,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
      },
    }),
    AppRoutingModule,
    BetLimitPopupModule,
    BrowserModule,
    BrowserAnimationsModule,
  ],
  providers: [
    ErrorPopupService,
    LoginService,
    BrandingService,
    HttpService,
    UtilService,
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryInterceptor,
      multi: true,
    },
    {
      provide: ANALYTICS_INSTANCE,
      useFactory: () => inject(AppInitService).analyticsInstance,
    },
    provideAppInitializer(() => {
      const initializerFn = appInitializerFactory();
      return initializerFn();
    }),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      useFactory: () => inject(Router),
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        inject(Sentry.TraceService);
        return () => {};
      },
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
